import { PLANS, DELIVERY_TIMES } from '../constants';

interface PriceCalculationParams {
  plan: string;
  isExperienced: boolean;
  language: string;
  deliveryTime: number;
}

export const calculatePrice = ({
  plan,
  isExperienced,
  language,
  deliveryTime
}: PriceCalculationParams): number => {
  const planData = PLANS[plan as keyof typeof PLANS];
  const basePrice = !isExperienced 
    ? planData.basePrice.freshGraduate.singleLanguage
    : planData.basePrice.experienced.singleLanguage;
  
  // Apply 30% discount to base price
  const discountedBasePrice = Math.round(basePrice * 0.7);
  
  // Add language price (40 SAR for both languages)
  const languagePrice = language === 'both' ? 40 : 0;
  
  // Add delivery time price
  const deliveryTimePrice = DELIVERY_TIMES.find(t => t.days === deliveryTime)?.price || 0;
  
  return discountedBasePrice + languagePrice + deliveryTimePrice;
};

export const formatPrice = (price: number): string => {
  return price.toLocaleString('ar-SA');
};

export const getPlanTitle = (planKey: string): string => {
  return PLANS[planKey as keyof typeof PLANS]?.title || '';
};

export const getDeliveryTimeLabel = (days: number): string => {
  return DELIVERY_TIMES.find(t => t.days === days)?.label || '';
};

export const getLanguageLabel = (languageKey: string): string => {
  switch (languageKey) {
    case 'both':
      return 'عربي وإنجليزي';
    case 'arabicOnly':
      return 'عربي فقط';
    case 'englishOnly':
      return 'إنجليزي فقط';
    default:
      return '';
  }
};